<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Cashier') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="py-1 px-2">
                <v-text-field
                  id="cashier-focus-me"
                  v-model="form.cashier_name"
                  :label="`${$t('Cashier Name')} *`"
                  name="Cashier Name"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Cashier Name')"
                  v-validate="'required'"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 class="py-1 px-2">
                <v-text-field
                  v-model="form.amount_iq"
                  :label="`${$t('Amount')} (${systemCurrency}) *`"
                  name="Amount"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Amount')"
                  v-validate="'required|numeric|min_value:1'"
                />
              </v-flex>
              <v-flex xs6 sm6 md6 class="py-1 px-2">
                <v-text-field
                  v-model="form.begin_iq"
                  :label="`${$t('Begin')} (${systemCurrency}) *`"
                  name="Begin"
                  hide-details
                  box
                  background-color="white"
                  :error="errors.has('Begin')"
                  v-validate="'required|numeric|min_value:1'"
                />
              </v-flex>

              <v-flex xs6 sm6 class="pa-2">
                <v-menu offset-y full-width :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="formatStartTime"
                    :label="$t('Start Time')"
                    prepend-inner-icon="schedule"
                    box
                    hide-details
                    name="start_time"
                    background-color="white"
                    autocomplete="off"
                  />
                  <v-time-picker v-model="form.start_time" width="318" />
                </v-menu>
              </v-flex>
              <v-flex xs6 sm6 class="pa-2">
                <v-menu offset-y full-width :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="formatEndTime"
                    :label="$t('End Time')"
                    prepend-inner-icon="schedule"
                    box
                    hide-details
                    background-color="white"
                    name="end_time"
                    autocomplete="off"
                  />
                  <v-time-picker v-model="form.end_time" width="318" />
                </v-menu>
              </v-flex>

              <v-flex pa-2>
                <v-autocomplete
                  v-model="form.outlet_id_fk"
                  :items="outletsList"
                  :label="`${$t('Outlet')} *`"
                  box
                  hide-details
                  :error="errors.has('Outlet')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Outlet"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs1 pt-2 v-if="hasPermissions(['outlets_store'])">
                <v-tooltip top>
                  <v-btn label @click="dialogs.addOutlet = true" slot="activator" icon fab small color="green">
                    <v-icon color="white">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new outlet') }}</span>
                </v-tooltip>
              </v-flex>

              <v-flex pa-2>
                <v-autocomplete
                  v-model="form.user_id_fk"
                  :items="staffsList"
                  :label="`${$t('Staff')} *`"
                  box
                  hide-details
                  :error="errors.has('Staff')"
                  background-color="white"
                  v-validate="'required'"
                  data-vv-name="Staff"
                  :menu-props="{ transition: 'slide-y-transition' }"
                />
              </v-flex>

              <v-flex xs1 pt-2 v-if="hasPermissions(['users_store'])">
                <v-tooltip top>
                  <v-btn label @click="dialogs.addStaff = true" slot="activator" icon fab small color="green">
                    <v-icon color="white">add</v-icon>
                  </v-btn>
                  <span>{{ $t('Add new staff') }}</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>

    <add-outlet
      :addDialog="dialogs.addOutlet"
      @reset-datatable="setOutletsList()"
      @hidemodal="dialogs.addOutlet = false"
    />

    <add-staff
      :addDialog="dialogs.addStaff"
      @reset-datatable="setStaffsList()"
      @hidemodal="resetAllErrors(true), (dialogs.addStaff = false)"
    />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import addOutlet from '@/views/preferences/outlets/addOutlet.vue'
import addStaff from '@/views/staff/staff/addStaff.vue'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  components: {
    addOutlet,
    addStaff
  },

  data() {
    return {
      dialogs: {
        addOutlet: false,
        addStaff: false
      },
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      form: {},
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      outletsList: 'outlets/getFullOutletsList',
      staffsList: 'staff/getFullStaffsList'
    }),

    formatStartTime() {
      if (!this.form.start_time) {
        return ''
      }
      return helpers.formatTimeForDisplay(this.form.start_time)
    },

    formatEndTime() {
      if (!this.form.end_time) {
        return ''
      }
      return helpers.formatTimeForDisplay(this.form.end_time)
    }
  },

  mounted() {
    this.setOutletsList()
    this.setStaffsList()
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addCashier: 'cashiers/addCashier',
      setOutletsList: 'outlets/setFullOutletsList',
      setStaffsList: 'staff/setFullStaffsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('cashier-focus-me').focus()
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)
            formData.append('cashier_name', this.form.cashier_name)
            formData.append('amount_iq', this.form.amount_iq)
            formData.append('begin_iq', this.form.begin_iq)
            formData.append('outlet_id_fk', this.form.outlet_id_fk)
            formData.append('user_id_fk', this.form.user_id_fk)

            this.addCashier(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
